export default __webpack_public_path__ + "static/media/8.d5cc4f48.jpg";